import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export const PopupDialog = ({
  name = "",
  open = false,
  onClose = () => {},
  title = "",
  content = null,
  positiveAction = null,
  neutralAction = () => {},
  negativeAction = null,
}) => {
  const inputProps = {
    name,
    open,
    onClose,
  };

  return (
    <Dialog {...inputProps} maxWidth="xl" fullWidth={true}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        {positiveAction}
        {negativeAction}
        <Button onClick={neutralAction}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

PopupDialog.propTypes = {
  name: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.element,
  positiveAction: PropTypes.element,
  neutralAction: PropTypes.func,
  negativeAction: PropTypes.element,
};
